var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 100 125"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 26H61v-7H39v7H24v9h4.333l4 46h35.334l4-46H76zm-35-5h18v5H41zm24.833 58H34.167l-3.826-44h39.318zM74 33H26v-5h48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 39.94h2V74h-2zM61.498 39.94h-1.996l-2 34.06h1.996z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m42.498 74-2-34.06h-1.996l2 34.06z"
  })));
};
export default SvgTrash;